import { Users } from "../modules";

export const ClientesPage = () => {
  return <Users variant="clients" />;
};
